import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { PopupMessageWrapper } from './PopupMessageWrapper';

const COPPER = 'rgb(184, 115, 51)';

interface ChallengeAcknowledgePromptProps {
    open: boolean;
    challengeName?: string;
    onAcknowledge: () => void;
}

export const ChallengeAcknowledgePrompt = ({
    open,
    challengeName,
    onAcknowledge,
}: ChallengeAcknowledgePromptProps) => {
    return (
        <PopupMessageWrapper open={open}>
            <Stack direction="column" spacing={2} sx={{ minWidth: 260, maxWidth: 400, textAlign: 'center' }}>
                <Typography variant="h6" sx={{ color: 'sepia.dark', fontWeight: 700 }}>
                    On Course Challenge
                </Typography>
                <Typography variant="h5" sx={{ color: 'sepia.main', fontWeight: 700 }}>
                    {challengeName}
                </Typography>
                <Typography variant="body1" sx={{ color: 'sepia.main' }}>
                    Use the tools button in the bottom navigation to access the challenge submission.
                </Typography>
                <Button
                    variant="contained"
                    onClick={onAcknowledge}
                    sx={{
                        backgroundColor: COPPER,
                        color: '#fff',
                        fontWeight: 600,
                        '&:hover': { backgroundColor: 'rgba(184, 115, 51, 0.85)' },
                    }}
                >
                    Got it
                </Button>
            </Stack>
        </PopupMessageWrapper>
    );
};
